export class LogTrustPrevRequest {
    idLogin: string;
    idFunc: string;
    idClass: string;
    idEvento: string;
    nmLog: string;
}